import credits from "../constants/photoCredits.json";

interface Credit {
  file: string;
  page: string;
  artist: string;
  license: string;
}

const ENTRIES = Object.values(credits as Record<string, Credit>);

export default function PhotoCredits() {
  return (
    <footer className="photo-credit">
      <details>
        <summary>Photography: U.S. military and Wikimedia Commons contributors</summary>
        <ul>
          {ENTRIES.map((entry) => (
            <li key={entry.page}>
              <a href={entry.page} target="_blank" rel="noreferrer">{entry.file.replace(/\.[a-z]+$/i, "")}</a>
              <span> · {entry.artist || "Unknown"} · {entry.license}</span>
            </li>
          ))}
        </ul>
      </details>
    </footer>
  );
}
